import React from 'react'

export const DownTimeIcon = (props: any) => {
  return (
    <svg
      id='prefix__Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x={0}
      y={0}
      viewBox='0 0 37.94 39.14'
      xmlSpace='preserve'
      width='1em'
      height='1em'
      {...props}
    >
      <style>{'.prefix__st0{fill:#ff0004}'}</style>
      <path
        className='prefix__st0_downtime'
        d='M20.3 32.76h-1.63a2.39 2.39 0 01-2.39-2.39v-.55c-.56-.18-1.11-.41-1.63-.68l-.39.39c-.95.95-2.46.92-3.38 0l-1.15-1.15c-.92-.92-.95-2.44 0-3.38l.39-.39c-.27-.52-.5-1.07-.68-1.63h-.55a2.39 2.39 0 01-2.39-2.39v-1.63a2.39 2.39 0 012.39-2.39h.55c.18-.56.41-1.11.68-1.63l-.39-.39c-.95-.95-.92-2.46 0-3.38l1.15-1.15c.92-.92 2.44-.95 3.38 0l.39.39c.52-.27 1.07-.5 1.63-.68v-.55a2.39 2.39 0 012.39-2.39h1.63a2.39 2.39 0 012.39 2.39v.55c.56.18 1.11.41 1.63.68l.39-.39c.95-.95 2.46-.92 3.38 0l1.15 1.15c.92.92.95 2.44 0 3.38l-.39.39c.27.52.5 1.07.68 1.63h.55a2.39 2.39 0 012.39 2.39v1.63a2.39 2.39 0 01-2.39 2.39h-.55c-.18.56-.41 1.11-.68 1.63l.39.39c.95.95.92 2.46 0 3.38l-1.15 1.15c-.92.92-2.44.95-3.38 0l-.39-.39c-.52.27-1.07.5-1.63.68v.55a2.39 2.39 0 01-2.39 2.39zm-5.4-5.22c.73.43 1.51.75 2.33.97.34.09.57.39.57.74v1.12c0 .48.39.87.87.87h1.63c.48 0 .87-.39.87-.87v-1.12c0-.35.23-.65.57-.74.82-.21 1.6-.54 2.33-.97.3-.18.68-.13.93.12l.8.8c.34.34.89.34 1.23 0l1.15-1.15c.33-.33.35-.88 0-1.23l-.8-.8a.772.772 0 01-.12-.93c.43-.73.75-1.51.97-2.33a.76.76 0 01.74-.57h1.12c.48 0 .87-.39.87-.87v-1.63a.87.87 0 00-.87-.87h-1.12a.76.76 0 01-.74-.57c-.21-.82-.54-1.6-.97-2.33-.18-.3-.13-.68.12-.93l.8-.8a.87.87 0 000-1.23l-1.15-1.15a.878.878 0 00-1.23 0l-.8.8c-.25.25-.63.29-.93.12-.73-.43-1.51-.75-2.33-.97a.76.76 0 01-.57-.74v-1.1a.87.87 0 00-.87-.87h-1.63a.87.87 0 00-.87.87v1.12c0 .35-.23.65-.57.74-.82.21-1.6.54-2.33.97-.3.18-.68.13-.93-.12l-.8-.8a.87.87 0 00-1.23 0l-1.15 1.15c-.33.33-.35.88 0 1.23l.8.8c.25.25.29.63.12.93-.43.73-.75 1.51-.97 2.33a.76.76 0 01-.74.57H8.89a.87.87 0 00-.87.87v1.63c0 .48.39.87.87.87h1.12c.35 0 .65.23.74.57.21.82.54 1.6.97 2.33.18.3.13.68-.12.93l-.8.8a.87.87 0 000 1.23l1.15 1.15c.33.33.89.34 1.23 0l.8-.8c.18-.2.55-.35.92-.14z'
      />
      <path
        className='prefix__st0_downtime'
        d='M19.48 25.42c-3.12 0-5.65-2.54-5.65-5.65s2.54-5.65 5.65-5.65 5.65 2.54 5.65 5.65-2.53 5.65-5.65 5.65zm0-9.78a4.131 4.131 0 000 8.26 4.131 4.131 0 000-8.26z'
      />
    </svg>
  )
}

export const EnhancementsIcon = (props: any) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 37.94 39.14'
      width='1em'
      height='1em'
      {...props}
    >
      <path
        d='M32.4 26.02v.31c-.14.19-.25.41-.41.57-1.58 1.6-3.16 3.19-4.75 4.77-.16.16-.38.27-.58.4h-.26c-.19-.13-.41-.24-.58-.4-1.91-1.9-3.82-3.8-5.73-5.71-.26-.26-.52-.54-.79-.82-.1.09-.16.14-.22.2-2.09 2.09-4.18 4.19-6.28 6.28-.18.18-.4.3-.6.45h-.31c-.2-.15-.43-.28-.61-.45-1.59-1.58-3.17-3.16-4.75-4.74-.51-.52-.51-.88 0-1.4 2.1-2.1 4.2-4.21 6.3-6.31.07-.07.14-.14.22-.23-.08-.08-.14-.15-.21-.22-1.76-1.76-3.52-3.51-5.27-5.28-.16-.16-.3-.39-.34-.61-.37-2.02-.72-4.05-1.07-6.07-.09-.57.37-1.02.94-.92 1.83.32 3.66.66 5.5.95.64.1 1.13.36 1.58.82 1.61 1.65 3.25 3.27 4.88 4.9.06.06.13.13.21.2.08-.08.15-.14.21-.2 2.11-2.11 4.22-4.21 6.33-6.32.5-.5.86-.5 1.37.01 1.59 1.58 3.19 3.17 4.77 4.76.16.17.29.37.43.56v.36c-.15.2-.27.41-.44.58-2.08 2.09-4.17 4.18-6.26 6.27-.07.07-.15.11-.24.17.1.11.16.17.22.23 2.1 2.11 4.21 4.22 6.31 6.33.17.16.29.37.43.56zM9.19 12.78c5.77 5.79 11.55 11.6 17.32 17.39l1.42-1.42-17.36-17.36c-.46.47-.94.95-1.38 1.39zm21.28 13.4L13.14 8.82c-.47.47-.95.95-1.38 1.39 5.78 5.78 11.57 11.58 17.32 17.35.45-.45.93-.93 1.39-1.38zm-18.45 3.96c2.04-2.04 4.09-4.07 6.1-6.08l-3.95-3.95c-.5.49-1.02 1.01-1.55 1.53.05.06.12.13.18.19.46.47.93.93 1.4 1.4.24.24.3.54.18.85-.11.3-.35.45-.67.47-.27.02-.47-.1-.66-.29-.45-.46-.91-.91-1.36-1.36a2.32 2.32 0 00-.18-.16c-.5.5-.97.98-1.45 1.47.04.04.1.11.16.17l1.32 1.32c.4.4.44.87.11 1.2-.34.34-.8.3-1.21-.12L9.1 25.44c-.05-.05-.11-.1-.12-.11-.31.31-.61.6-.88.87 1.29 1.31 2.62 2.64 3.92 3.94zM24.55 9.71c-.51.51-.99 1-1.51 1.52.05.04.14.08.21.15.47.47.95.94 1.41 1.41.27.28.29.7.08.99-.23.3-.62.41-.96.23-.12-.06-.22-.16-.32-.25-.5-.5-.99-1.01-1.46-1.48-.55.55-1.06 1.06-1.55 1.56 1.31 1.31 2.64 2.64 3.95 3.94 2.03-2.01 4.08-4.05 6.07-6.03-1.32-1.35-2.64-2.69-3.93-4.02-.3.31-.59.6-.92.93.05.04.14.09.2.15.47.46.93.93 1.4 1.4.24.24.3.54.17.85-.11.29-.34.44-.65.47-.27.02-.48-.09-.66-.28-.52-.52-1.03-1.03-1.53-1.54zM7.87 7.54l.63 3.58c.99-.98 1.98-1.97 2.97-2.95-1.17-.2-2.36-.41-3.6-.63z'
        fill='#00d36c'
      />
    </svg>
  )
}

export const InsightIcon = (props: any) => {
  return (
    <svg
      id='prefix__Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x={0}
      y={0}
      viewBox='0 0 37.94 39.14'
      xmlSpace='preserve'
      width='1em'
      height='1em'
      {...props}
    >
      <style>{'.prefix__st0__insight{fill:#ff70ac}'}</style>
      <g id='prefix__e5e8Qc_tif_2_'>
        <path
          className='prefix__st0__insight'
          d='M20.3 9.89c.86.22 1.74.39 2.58.67 4.17 1.43 7.29 4.26 9.96 7.63.21.27.23.97.03 1.23-3.1 3.87-6.7 7.08-11.76 8.08-3.76.75-7.02-.59-10.05-2.66-2.27-1.55-4.15-3.52-5.85-5.66v-.74c2.78-3.47 5.97-6.41 10.28-7.88.84-.29 1.72-.45 2.57-.66.75-.01 1.5-.01 2.24-.01zm-1.34 1.85c-.27.03-.79.07-1.31.17-4.22.81-7.27 3.43-10 6.52-.14.15-.05.74.13.9 1.77 1.59 3.45 3.32 5.42 4.63 3.48 2.32 7.23 2.55 11.02.57 2.51-1.31 4.56-3.18 6.46-5.24.39-.42.2-.68-.09-1.01-1.67-1.9-3.54-3.56-5.74-4.83-1.74-1.02-3.59-1.67-5.89-1.71z'
        />
        <path
          className='prefix__st0__insight'
          d='M24.72 18.8c.01 2.98-2.5 5.5-5.51 5.53-2.98.03-5.52-2.46-5.57-5.47-.06-2.98 2.55-5.6 5.56-5.58 2.99.01 5.51 2.53 5.52 5.52zm-1.84-.01c-.01-1.98-1.69-3.65-3.69-3.67-1.97-.01-3.68 1.67-3.7 3.65-.02 2.01 1.72 3.74 3.73 3.71 1.99-.02 3.67-1.71 3.66-3.69z'
        />
      </g>
    </svg>
  )
}

export const KnownIssuesIcon = (props: any) => {
  return (
    <svg
      id='prefix__Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x={0}
      y={0}
      viewBox='0 0 37.94 39.14'
      xmlSpace='preserve'
      width='1em'
      height='1em'
      {...props}
    >
      <style>{'.prefix__st0__knownissues{fill:#ff8d00}'}</style>
      <path
        className='prefix__st0__knownissues'
        d='M18.82 22.99c-.71 0-1.3.59-1.3 1.3 0 .71.59 1.3 1.3 1.3.68 0 1.3-.59 1.27-1.27.03-.74-.56-1.33-1.27-1.33z'
      />
      <path
        className='prefix__st0__knownissues'
        d='M30.87 27.61c.82-1.41.82-3.09.01-4.5L22.72 8.98c-.81-1.42-2.27-2.27-3.9-2.27s-3.09.85-3.9 2.26L6.75 23.12c-.81 1.42-.81 3.11.02 4.53.81 1.4 2.27 2.23 3.89 2.23h16.29c1.63 0 3.09-.85 3.92-2.27zm-1.77-1.02a2.46 2.46 0 01-2.15 1.24H10.66c-.89 0-1.68-.45-2.12-1.22a2.47 2.47 0 01-.01-2.48L16.7 10c.44-.78 1.23-1.23 2.13-1.23.89 0 1.69.46 2.13 1.24l8.16 14.13c.43.75.42 1.67-.02 2.45z'
      />
      <path
        className='prefix__st0__knownissues'
        d='M18.49 13.85c-.62.18-1.01.74-1.01 1.42l.09 1.24.27 4.67c.03.53.44.92.97.92s.95-.41.97-.95c0-.32 0-.62.03-.95l.18-3.02c.03-.65.09-1.3.12-1.95 0-.23-.03-.44-.12-.65-.26-.58-.88-.87-1.5-.73z'
      />
    </svg>
  )
}

export const GeneralNotificationsIcon = (props: any) => {
  return (
    <svg
      id='prefix__Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x={0}
      y={0}
      viewBox='0 0 37.94 39.14'
      xmlSpace='preserve'
      width='1em'
      height='1em'
      {...props}
    >
      <style>{'.prefix__st0__general_notifications{fill:#008ef1}'}</style>
      <path
        className='prefix__st0__general_notifications'
        d='M36.25 20.07c-.27.58-.73.77-1.35.75-.85-.03-1.69-.01-2.54-.01-.68 0-1.13-.41-1.13-1 0-.6.45-1 1.13-1 .85 0 1.7.02 2.54-.01.62-.03 1.08.17 1.35.75v.52zM14 24.86v4.81c0 .59-.11 1.15-.4 1.67-.62 1.12-1.9 1.71-3.22 1.47-1.2-.22-2.21-1.28-2.36-2.51-.03-.24-.05-.49-.05-.73 0-1.52-.01-3.04 0-4.56 0-.24-.05-.37-.29-.47-.66-.29-1.14-.78-1.43-1.44-.09-.2-.19-.27-.41-.28a4.016 4.016 0 01-3.9-4.14c.06-2.07 1.76-3.8 3.83-3.87.27-.01.39-.1.52-.34.58-1.13 1.53-1.68 2.79-1.68 1.89-.01 3.78-.01 5.66 0 1.83.01 3.56-.39 5.08-1.42.84-.57 1.56-1.32 2.33-2 .07-.06.08-.18.11-.27.4-1.48 1.73-2.47 3.14-2.32 1.63.17 2.79 1.34 2.8 2.97.03 6.05.02 12.1 0 18.16-.01 1.3-.68 2.26-1.89 2.76-1.2.5-2.49.19-3.35-.8-.29-.33-.44-.79-.66-1.18-.11-.21-.2-.44-.36-.61-.94-1.02-2-1.87-3.28-2.43-1.32-.62-3.17-.94-4.66-.79zm2.03-10.13v8.14c1.14.11 2.22.38 3.26.81 1.03.43 1.97 1.01 2.86 1.74V12.16c-1.8 1.5-3.82 2.33-6.12 2.57zm-2.06 8.09v-8.03c-1.71 0-3.39-.01-5.07.01-.52.01-.93.43-.93.96-.01 2.03-.01 4.06 0 6.09 0 .53.41.96.93.96 1.68.02 3.37.01 5.07.01zm12.22-4.02v-8.78c0-.8-.37-1.27-1.01-1.27s-1.01.47-1.01 1.27v17.55c0 .12-.01.25.01.37.06.51.49.9 1 .9s.94-.39 1-.9c.01-.12.01-.25.01-.37V18.8zm-16.18 6.05c-.01.03-.03.05-.03.07 0 1.66-.01 3.32 0 4.98 0 .43.25.73.65.89.68.26 1.35-.24 1.35-1.01.01-1.57 0-3.14 0-4.72 0-.07-.02-.15-.03-.22-.66.01-1.3.01-1.94.01zm-4.08-4.06V16.8c-1.13.03-1.99.9-1.99 1.99 0 1.1.86 1.97 1.99 2zM31.25 16.84c-.42-.05-.8-.29-.95-.66-.17-.41-.09-.8.22-1.11.66-.67 1.32-1.33 1.99-1.99.02-.02.05-.04.08-.07.43-.35.99-.32 1.36.06.37.38.41.96.03 1.36-.68.72-1.39 1.42-2.11 2.1-.16.16-.41.21-.62.31zM34.24 25.75c-.03.48-.2.78-.54.97-.36.19-.75.21-1.04-.07-.77-.72-1.53-1.47-2.25-2.24-.34-.36-.26-.93.09-1.28.35-.36.93-.44 1.3-.09.76.72 1.5 1.47 2.22 2.22.15.14.18.37.22.49z'
      />
    </svg>
  )
}

export const DataReleaseIcon = (props: any) => {
  return (
    <svg
      id='prefix__Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x={0}
      y={0}
      viewBox='0 0 37.94 39.14'
      xmlSpace='preserve'
      width='1em'
      height='1em'
      {...props}
    >
      <style>{'.prefix__st0__data_release{fill:#8477c6}'}</style>
      <path
        className='prefix__st0__data_release'
        d='M19.03 34.72c-.84-.37-1.68-.74-2.52-1.1-3.28-1.4-6.55-2.8-9.83-4.2-.48-.2-.69-.55-.68-1.07V18.26v-.62c0-.59.22-.9.78-1.1 1.96-.7 3.92-1.4 5.87-2.1.46-.16.92-.33 1.38-.5.12-.04.22-.08.28.08.19.55.39 1.1.6 1.69-1.67.6-3.32 1.2-5.02 1.81.1.06.16.1.22.12 2.98 1.13 5.95 2.26 8.93 3.38.14.05.33.07.47.02 2.94-1.11 5.88-2.23 8.81-3.35.07-.03.14-.06.25-.12-1.73-.63-3.41-1.24-5.13-1.86.23-.62.44-1.21.67-1.83.15.05.27.08.4.12 2.39.87 4.77 1.73 7.16 2.6.53.19.75.5.75 1.03 0 3.55-.01 7.09.01 10.64 0 .61-.25.97-.81 1.21-3.97 1.71-7.94 3.43-11.91 5.15-.05.02-.1.06-.15.08-.18.01-.35.01-.53.01zm-.75-2.5c.02-.11.03-.15.03-.2 0-2.97 0-5.94.01-8.91 0-.2-.09-.27-.26-.33-3.27-1.24-6.53-2.48-9.8-3.72-.09-.03-.18-.06-.28-.09-.01.1-.02.17-.02.24 0 2.78.01 5.57 0 8.35 0 .22.1.3.28.38 2.95 1.25 5.89 2.51 8.83 3.77.39.17.78.33 1.21.51zm2.02-.02c.11-.04.18-.05.24-.08 3.23-1.4 6.45-2.8 9.68-4.19.2-.09.24-.21.24-.4v-8.21c0-.09-.01-.19-.02-.3-.11.04-.19.06-.27.09-3.21 1.22-6.42 2.45-9.63 3.67-.21.08-.25.19-.25.39v8.7c-.01.1 0 .2.01.33z'
      />
      <path
        className='prefix__st0__data_release'
        d='M14.22 11.1c1.69-2.15 3.32-4.23 4.99-6.36 1.66 2.11 3.29 4.19 4.97 6.33-.16.01-.26.02-.35.02-.64 0-1.29.01-1.93 0-.27-.01-.35.08-.35.35.01 2.3 0 4.59.01 6.89 0 .3-.09.38-.38.38-1.3-.02-2.6-.01-3.9-.01-.4 0-.41 0-.41-.39 0-2.26 0-4.51-.01-6.77 0-.44 0-.44-.44-.44h-2.2z'
      />
    </svg>
  )
}
